import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-f8f1b51a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bg-white rounded-lg shadow pt-4 max-w-7xl mx-auto" }
const _hoisted_2 = { class: "md:flex justify-between items-center px-4 md:px-6 pb-4" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h3", { class: "text-lg font-medium leading-6 text-gray-900" }, "OM Tracker"),
  /*#__PURE__*/_createElementVNode("p", { class: "mt-1 text-sm text-gray-500" }, "Let’s take this deal to market")
], -1))
const _hoisted_4 = { class: "flex justify-start md:justify-end items-center mt-4 md:mt-0" }
const _hoisted_5 = { class: "text-sm font-medium text-gray-500" }
const _hoisted_6 = {
  key: 0,
  class: "flex items-center justify-end space-x-2"
}
const _hoisted_7 = ["checked"]
const _hoisted_8 = { class: "col-span-8 md:col-span-3" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "font-normal text-gray" }
const _hoisted_11 = { class: "text-sm leading-5 font-normal" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "col-span-8 md:col-span-3" }
const _hoisted_14 = { class: "text-sm leading-5 font-normal text-gray-500" }
const _hoisted_15 = { class: "text-sm leading-5 font-normal text-gray-500 flex items-center" }
const _hoisted_16 = { class: "col-span-8 md:col-span-2 md:text-right" }
const _hoisted_17 = { class: "flex items-center justify-end" }
const _hoisted_18 = { class: "inline-flex items-center md:flex-col" }
const _hoisted_19 = { key: 2 }
const _hoisted_20 = ["onClick"]
const _hoisted_21 = ["onClick", "checked"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PencilIcon = _resolveComponent("PencilIcon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_UsersIcon = _resolveComponent("UsersIcon")!
  const _component_ShieldCheckIcon = _resolveComponent("ShieldCheckIcon")!
  const _component_MailIcon = _resolveComponent("MailIcon")!
  const _component_CheckIcon = _resolveComponent("CheckIcon")!
  const _component_XIcon = _resolveComponent("XIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_router_link, {
          class: "flex items-center px-3 py-2 bg-indigo-100 hover:bg-sky text-sky hover:text-white text-sm rounded-md mr-2",
          to: { name: 'deal-editor' }
        }, {
          default: _withCtx(() => [
            _createVNode(_component_PencilIcon, { class: "w-4 h-4 mr-1" }),
            _createTextVNode(" Edit OM ")
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, {
          class: "px-3 py-2 bg-sky text-white text-sm rounded-md flex items-center",
          to: { name: 'deal-shortlist' }
        }, {
          default: _withCtx(() => [
            _createVNode(_component_UsersIcon, { class: "w-4 h-4 mr-2" }),
            _createTextVNode(" Edit shortlist ")
          ]),
          _: 1
        })
      ])
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.distributionsByStatus, (value, key) => {
      return (_openBlock(), _createElementBlock("section", { key: key }, [
        _createElementVNode("div", {
          class: _normalizeClass(["px-4 md:px-6 bg-gray-100 border-t border-b py-1 flex items-center justify-between", { 'py-2': key.toString() == 'Added' }])
        }, [
          _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.sectionNamesMap[key]), 1),
          (key.toString() == 'Added')
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("button", {
                  type: "button",
                  class: _normalizeClass(["bg-gray-200 text-sm px-3 py-1 rounded-lg hover:bg-gray-300", { 'opacity-50 pointer-events-none': !_ctx.bulkSendList.size }]),
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showModal('ModalBulkEmailSend', { bulkSendList: Array.from(_ctx.bulkSendList), deal: _ctx.deal })))
                }, " Group send ", 2),
                _createElementVNode("input", {
                  type: "checkbox",
                  name: "selectAll",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.updateAll && _ctx.updateAll(...args))),
                  checked: _ctx.bulkSendList.size == value.length
                }, null, 8, _hoisted_7)
              ]))
            : _createCommentVNode("", true)
        ], 2),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(value, ({ originator, lender, status, id, modifiedDate }, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: _normalizeClass(["grid grid-cols-8 gap-6 px-4 md:px-6 py-4 items-center", { 'border-t': index > 0 }]),
            key: index
          }, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("p", {
                class: "text-sm leading-5 font-medium text-sky cursor-pointer",
                onClick: ($event: any) => (_ctx.showProfile(originator.id))
              }, [
                _createTextVNode(_toDisplayString(originator['name']) + " ", 1),
                _createElementVNode("span", _hoisted_10, "(" + _toDisplayString(originator['email']) + ")", 1)
              ], 8, _hoisted_9),
              _createElementVNode("p", _hoisted_11, _toDisplayString(lender['name']), 1),
              (status == 'Added')
                ? (_openBlock(), _createElementBlock("span", {
                    key: 0,
                    class: "text-red-600 text-sm mt-1 font-medium cursor-pointer",
                    onClick: ($event: any) => (_ctx.updateOriginatorsList(originator.id))
                  }, " Remove ", 8, _hoisted_12))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("p", _hoisted_14, _toDisplayString(originator.lastLogin ? `Last login ${_ctx.moment(originator.lastLogin)}` : 'Never logged in'), 1),
              _createElementVNode("p", _hoisted_15, [
                _createVNode(_component_ShieldCheckIcon, {
                  class: _normalizeClass(["w-4 h-4 mr-1", {
                'is-active': originator.isVerified,
                'text-gray-400': !originator.isVerified
              }])
                }, null, 8, ["class"]),
                _createTextVNode(" " + _toDisplayString(originator.isVerified ? 'Verified' : 'Not verified yet'), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  (status == 'Added' && !!id)
                    ? (_openBlock(), _createBlock(_component_router_link, {
                        key: 0,
                        to: { name: 'deal-om-send', params: { distributionId: id } },
                        class: "py-1.5 px-3 flex items-center bg-gray-100 hover:bg-gray-200 rounded-full text-xs font-medium mr-2 md:mr-0"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_MailIcon, { class: "w-4 h-4 mr-1 text-gray-500" }),
                          _createTextVNode(" Send OM ")
                        ]),
                        _: 2
                      }, 1032, ["to"]))
                    : (_openBlock(), _createElementBlock("span", {
                        key: 1,
                        class: _normalizeClass(["py-1.5 px-3 flex items-center rounded-full text-xs font-medium", {
                  'bg-yellow-50': status === 'SentMessage',
                  'bg-green-100': status === 'Opened' || status === 'Viewed',
                  'bg-green-500 text-white': status === 'Quoted',
                  'bg-gray-100': status === 'NotInterested' || status == 'Previewed'
                }])
                      }, [
                        (status !== 'NotInterested')
                          ? (_openBlock(), _createBlock(_component_CheckIcon, {
                              key: 0,
                              class: _normalizeClass(["w-4 h-4 mr-1", {
                    'text-yellow-400': status === 'SentMessage',
                    'text-green-100': status === 'Quoted',
                    'text-green-500': status === 'Opened' || status === 'Viewed'
                  }])
                            }, null, 8, ["class"]))
                          : (_openBlock(), _createBlock(_component_XIcon, {
                              key: 1,
                              class: "w-4 h-4 mr-1 text-gray-500"
                            })),
                        _createTextVNode(" " + _toDisplayString(_ctx.sectionNamesMap[status] || status) + " ", 1),
                        (status=='SentMessage')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_19, " " + _toDisplayString(new Date(modifiedDate).toLocaleDateString()), 1))
                          : _createCommentVNode("", true)
                      ], 2)),
                  (status !== 'Quoted')
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 2,
                        href: "#",
                        onClick: _withModifiers(($event: any) => (_ctx.showProfile(originator.id)), ["prevent"]),
                        class: "text-xs leading-5 font-medium text-gray-700 md:mt-1 hover:text-gray-900"
                      }, " Show profile ", 8, _hoisted_20))
                    : (_openBlock(), _createBlock(_component_router_link, {
                        key: 3,
                        to: { name: 'deal-quotes' },
                        class: "text-xs leading-5 font-medium text-sky md:mt-1"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Review terms ")
                        ]),
                        _: 1
                      }))
                ]),
                (key.toString() === 'Added')
                  ? (_openBlock(), _createElementBlock("input", {
                      key: 0,
                      type: "checkbox",
                      name: "",
                      class: "ml-2 mb-5",
                      onClick: ($event: any) => (_ctx.updateBulkSendList(id)),
                      checked: _ctx.bulkSendList.has(id)
                    }, null, 8, _hoisted_21))
                  : _createCommentVNode("", true)
              ])
            ])
          ], 2))
        }), 128))
      ]))
    }), 128))
  ]))
}